import * as Yup from "yup";
import md5 from "crypto-js/md5";

import { transform as licenseTransformer } from "./License";
import { transform as roleTransformer } from "./Role";
import { transform as warningTransformer } from "./Warning";
import { userCan } from "../helpers/Auth";

export const UserValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
        .email("Valid email is required")
        .required("A valid email is required."),
    password: Yup.string(),
    passwordConfirmation: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
    ),
    licenses: Yup.array().min(1, "You must assign at least one publication"),
});

export const UserObjectSchema = {
    name: "",
    uuid: "",
    id: "",
    email: "",
    slug: "",
    is_admin: false,
    is_snworks: false,
    is_active: false,
    is_invited: false,
    licenses: [],
    roles: [],
    warnings: [],
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let user = Object.assign({}, UserObjectSchema, {
        id: parseInt(requestData.id),
        name: requestData.name,
        uuid: requestData.uuid,
        email: requestData.email,
        slug: requestData.slug,
        is_admin: requestData.is_admin,
        is_snworks: requestData.is_snworks,
        is_active: requestData.is_active,
        is_invited: requestData.is_invited,
        image_url: "https://www.gravatar.com/avatar/".concat(
            md5(requestData.email)
        ),
        can: function (action, permission = null) {
            return userCan(this, action, permission);
        },
        hydrateRoles: function (roleData) {
            this._hydratedRoles = roleData;
        },
        _hydratedRoles: {},
    });

    if (requestData.licenses) {
        let licenses = licenseTransformer(requestData.licenses);
        user = Object.assign({}, user, { licenses: licenses });
    }

    if (requestData.roles) {
        let roles = roleTransformer(requestData.roles);
        user = Object.assign({}, user, { roles: roles });
    }

    if (requestData.warnings) {
        let warnings = warningTransformer(requestData.warnings);
        user = Object.assign({}, user, { warnings: warnings });
    }

    return user;
}
